export var USERINPUTTYPE;
(function (USERINPUTTYPE) {
    USERINPUTTYPE[USERINPUTTYPE["LEFTCLICK"] = 0] = "LEFTCLICK";
    USERINPUTTYPE[USERINPUTTYPE["RIGHTCLICK"] = 1] = "RIGHTCLICK";
    USERINPUTTYPE[USERINPUTTYPE["MIDDLECLICK"] = 2] = "MIDDLECLICK";
    USERINPUTTYPE[USERINPUTTYPE["MOUSEMOVE"] = 3] = "MOUSEMOVE";
    USERINPUTTYPE[USERINPUTTYPE["LEFTMOUSEDOWN"] = 4] = "LEFTMOUSEDOWN";
    USERINPUTTYPE[USERINPUTTYPE["SCROLLWHEEL"] = 5] = "SCROLLWHEEL";
    USERINPUTTYPE[USERINPUTTYPE["KEY_SPACE"] = 6] = "KEY_SPACE";
    USERINPUTTYPE[USERINPUTTYPE["KEY_ENTER"] = 7] = "KEY_ENTER";
    USERINPUTTYPE[USERINPUTTYPE["KEY_ESC"] = 8] = "KEY_ESC";
    USERINPUTTYPE[USERINPUTTYPE["KEY_BACKSPACE"] = 9] = "KEY_BACKSPACE";
    USERINPUTTYPE[USERINPUTTYPE["KEY_TAB"] = 10] = "KEY_TAB";
    USERINPUTTYPE[USERINPUTTYPE["KEY_DELETE"] = 11] = "KEY_DELETE";
    USERINPUTTYPE[USERINPUTTYPE["GEOFRAMECHANGED"] = 12] = "GEOFRAMECHANGED";
    USERINPUTTYPE[USERINPUTTYPE["MOUSEDOWN"] = 13] = "MOUSEDOWN";
    USERINPUTTYPE[USERINPUTTYPE["MOUSEUP"] = 14] = "MOUSEUP";
    USERINPUTTYPE[USERINPUTTYPE["DOUBLECLICK"] = 15] = "DOUBLECLICK";
    USERINPUTTYPE[USERINPUTTYPE["STREAMCHANGED"] = 16] = "STREAMCHANGED";
    USERINPUTTYPE[USERINPUTTYPE["NAVIGATION_AXISCHANGED"] = 17] = "NAVIGATION_AXISCHANGED";
    USERINPUTTYPE[USERINPUTTYPE["MEASUREMENT_AXISCHANGED"] = 71] = "MEASUREMENT_AXISCHANGED";
    USERINPUTTYPE[USERINPUTTYPE["STREAMSTARTED"] = 18] = "STREAMSTARTED";
    USERINPUTTYPE[USERINPUTTYPE["STREAMSTOPPED"] = 19] = "STREAMSTOPPED";
    USERINPUTTYPE[USERINPUTTYPE["MOUSEOUT"] = 20] = "MOUSEOUT";
    USERINPUTTYPE[USERINPUTTYPE["MOUSEWHEEL"] = 21] = "MOUSEWHEEL";
    //Events from here are touch events
    USERINPUTTYPE[USERINPUTTYPE["TAP"] = 22] = "TAP";
    USERINPUTTYPE[USERINPUTTYPE["HOLD"] = 23] = "HOLD";
    USERINPUTTYPE[USERINPUTTYPE["DRAGSTART"] = 24] = "DRAGSTART";
    USERINPUTTYPE[USERINPUTTYPE["DRAGEND"] = 25] = "DRAGEND";
    USERINPUTTYPE[USERINPUTTYPE["DRAG"] = 26] = "DRAG";
    USERINPUTTYPE[USERINPUTTYPE["PINCH"] = 27] = "PINCH";
    USERINPUTTYPE[USERINPUTTYPE["TOUCH"] = 28] = "TOUCH";
    USERINPUTTYPE[USERINPUTTYPE["RELEASE"] = 29] = "RELEASE";
    USERINPUTTYPE[USERINPUTTYPE["DOUBLETAP"] = 30] = "DOUBLETAP";
    USERINPUTTYPE[USERINPUTTYPE["SWIPE"] = 31] = "SWIPE";
    //Events from here are other events again
    USERINPUTTYPE[USERINPUTTYPE["BUFFERING"] = 33] = "BUFFERING";
    USERINPUTTYPE[USERINPUTTYPE["KEY_CTRL"] = 34] = "KEY_CTRL";
    USERINPUTTYPE[USERINPUTTYPE["KEY_CTRL_UP"] = 35] = "KEY_CTRL_UP";
    USERINPUTTYPE[USERINPUTTYPE["KEY_SPACE_UP"] = 36] = "KEY_SPACE_UP";
    USERINPUTTYPE[USERINPUTTYPE["KEY_ENTER_UP"] = 37] = "KEY_ENTER_UP";
    USERINPUTTYPE[USERINPUTTYPE["KEY_ESC_UP"] = 38] = "KEY_ESC_UP";
    USERINPUTTYPE[USERINPUTTYPE["KEY_BACKSPACE_UP"] = 39] = "KEY_BACKSPACE_UP";
    USERINPUTTYPE[USERINPUTTYPE["KEY_TAB_UP"] = 40] = "KEY_TAB_UP";
    USERINPUTTYPE[USERINPUTTYPE["KEY_DELETE_UP"] = 41] = "KEY_DELETE_UP";
    USERINPUTTYPE[USERINPUTTYPE["KEY_ALT_UP"] = 42] = "KEY_ALT_UP";
    USERINPUTTYPE[USERINPUTTYPE["KEY_ALT"] = 43] = "KEY_ALT";
    USERINPUTTYPE[USERINPUTTYPE["KEY_SHIFT"] = 44] = "KEY_SHIFT";
    USERINPUTTYPE[USERINPUTTYPE["TILE_LOADING"] = 45] = "TILE_LOADING";
    USERINPUTTYPE[USERINPUTTYPE["KEY_ARROW_LEFT"] = 46] = "KEY_ARROW_LEFT";
    USERINPUTTYPE[USERINPUTTYPE["KEY_ARROW_RIGHT"] = 47] = "KEY_ARROW_RIGHT";
    USERINPUTTYPE[USERINPUTTYPE["KEY_ARROW_UP"] = 48] = "KEY_ARROW_UP";
    USERINPUTTYPE[USERINPUTTYPE["KEY_ARROW_DOWN"] = 49] = "KEY_ARROW_DOWN";
    USERINPUTTYPE[USERINPUTTYPE["KEY_C"] = 50] = "KEY_C";
    USERINPUTTYPE[USERINPUTTYPE["KEY_A"] = 51] = "KEY_A";
    USERINPUTTYPE[USERINPUTTYPE["KEY_D"] = 52] = "KEY_D";
    USERINPUTTYPE[USERINPUTTYPE["PANO_ROTATION"] = 53] = "PANO_ROTATION";
    USERINPUTTYPE[USERINPUTTYPE["PANO_ZOOM"] = 54] = "PANO_ZOOM";
    USERINPUTTYPE[USERINPUTTYPE["SCENE_ZOOM"] = 55] = "SCENE_ZOOM";
    USERINPUTTYPE[USERINPUTTYPE["KEY_CTRL_SHIFT"] = 57] = "KEY_CTRL_SHIFT";
    USERINPUTTYPE[USERINPUTTYPE["PLAYMODE_CHANGED"] = 58] = "PLAYMODE_CHANGED";
    USERINPUTTYPE[USERINPUTTYPE["MEASUREMODE_CHANGED"] = 59] = "MEASUREMODE_CHANGED";
    USERINPUTTYPE[USERINPUTTYPE["KEY_ARROW_LEFT_UP"] = 60] = "KEY_ARROW_LEFT_UP";
    USERINPUTTYPE[USERINPUTTYPE["KEY_ARROW_RIGHT_UP"] = 61] = "KEY_ARROW_RIGHT_UP";
    USERINPUTTYPE[USERINPUTTYPE["LAYERCHANGED"] = 62] = "LAYERCHANGED";
    USERINPUTTYPE[USERINPUTTYPE["LAYERADDED"] = 63] = "LAYERADDED";
    USERINPUTTYPE[USERINPUTTYPE["LAYERREMOVED"] = 64] = "LAYERREMOVED";
    USERINPUTTYPE[USERINPUTTYPE["LAYERUPDATED"] = 65] = "LAYERUPDATED";
    USERINPUTTYPE[USERINPUTTYPE["LAYERSAVED"] = 66] = "LAYERSAVED";
    USERINPUTTYPE[USERINPUTTYPE["IMAGECHANGED"] = 67] = "IMAGECHANGED";
    USERINPUTTYPE[USERINPUTTYPE["FEATURESELECTED"] = 68] = "FEATURESELECTED";
    USERINPUTTYPE[USERINPUTTYPE["FEATUREDESELECTED"] = 69] = "FEATUREDESELECTED";
    USERINPUTTYPE[USERINPUTTYPE["GEOFRAMECOLLECTIONCHANGED"] = 70] = "GEOFRAMECOLLECTIONCHANGED";
})(USERINPUTTYPE || (USERINPUTTYPE = {}));
/**
 * UserInput translate
 *
 * @author robert wüest, benjamin loesch
 *
 * @class UserInput
 * @constructor
 */
export class UserInput {
    /**
     * Get string of USERINPUTTYPE
     * @method ToString
     * @param {USERINPUTTYPE} type
     * @returns {string}
     * @static
     */
    static ToString(type) {
        switch (type) {
            case 0:
                return "LEFTCLICK";
            case 1:
                return "RIGHTCLICK";
            case 2:
                return "MIDDLECLICK";
            case 3:
                return "MOUSEMOVE";
            case 4:
                return "LEFTMOUSEDOWN";
            case 5:
                return "SCROLLWHEEL";
            case 6:
                return "KEY_SPACE";
            case 7:
                return "KEY_ENTER";
            case 8:
                return "KEY_ESC";
            case 9:
                return "KEY_BACKSPACE";
            case 10:
                return "KEY_TAB";
            case 11:
                return "KEY_DELETE";
            case 12:
                return "GEOFRAMECHANGED";
            case 13:
                return "MOUSEDOWN";
            case 14:
                return "MOUSEUP";
            case 15:
                return "DOUBLECLICK";
            case 16:
                return "STREAMCHANGED";
            case 17:
                return "NAVIGATION_AXISCHANGED";
            case 71:
                return "MEASUREMENT_AXISCHANGED"; // Added later
            case 18:
                return "STREAMSTARTED";
            case 19:
                return "STREAMSTOPPED";
            case 20:
                return "MOUSEOUT";
            case 21:
                return "MOUSEWHEEL";
            case 22:
                return "TAP";
            case 23:
                return "HOLD";
            case 24:
                return "DRAGSTART";
            case 25:
                return "DRAGEND";
            case 26:
                return "DRAG";
            case 27:
                return "PINCH";
            case 28:
                return "TOUCH";
            case 29:
                return "RELEASE";
            case 30:
                return "DOUBLETAP";
            case 31:
                return "SWIPE";
            case 33:
                return "BUFFERING";
            case 34:
                return "KEY_CTRL";
            case 35:
                return "KEY_CTRL_UP";
            case 36:
                return "KEY_SPACE_UP";
            case 37:
                return "KEY_ENTER_UP";
            case 38:
                return "KEY_ESC_UP";
            case 39:
                return "KEY_BACKSPACE_UP";
            case 40:
                return "KEY_TAB_UP";
            case 41:
                return "KEY_DELETE_UP";
            case 42:
                return "KEY_ALT_UP";
            case 43:
                return "KEY_ALT";
            case 44:
                return "KEY_SHIFT";
            case 45:
                return "TILE_LOADING";
            case 46:
                return "KEY_ARROW_LEFT";
            case 47:
                return "KEY_ARROW_RIGHT";
            case 48:
                return "KEY_ARROW_UP";
            case 49:
                return "KEY_ARROW_DOWN";
            case 50:
                return "KEY_C";
            case 51:
                return "KEY_A";
            case 52:
                return "KEY_D";
            case 53:
                return "PANO_ROTATION";
            case 54:
                return "PANO_ZOOM";
            case 55:
                return "SCENE_ZOOM";
            case 57:
                return "KEY_CTRL_SHIFT";
            case 58:
                return "PLAYMODE_CHANGED";
            case 59:
                return "MEASUREMODE_CHANGED";
            case 60:
                return "KEY_ARROW_LEFT_UP";
            case 61:
                return "KEY_ARROW_RIGHT_UP";
            case 62:
                return "LAYERCHANGED";
            case 63:
                return "LAYERADDED";
            case 64:
                return "LAYERREMOVED";
            case 65:
                return "LAYERUPDATED";
            case 66:
                return "LAYERSAVED";
            case 67:
                return "IMAGECHANGED";
            case 68:
                return "FEATURESELECTED";
            case 69:
                return "FEATUREDESELECTED";
            case 70:
                return "GEOFRAMECOLLECTIONCHANGED";
        }
        return "";
    }
}
//# sourceMappingURL=userinput.js.map